import LocalStorageService from './LocalStorageService'
import PostService from './PostService'
import UtilService from './UtilService'

export default class LoginService {
  constructor() {
    this.localStorageService = new LocalStorageService()
    this.postService = new PostService(this, false)
    this.util = new UtilService(true)
  }

  VerificarPermissaoFuncionario(cpf, callback, callbackErro) {
    let url = 'webapi/corporativo/api/pessoafisica/pesquisar?chave={CPF}&funcionario=true'.replace('{CPF}', cpf)
    this.postService.Get(url, (res) => {
      callback(res.length > 0)
    })
  }
}
